import { Instance } from 'mobx-state-tree';
import { AssignActionStatusDtoModelBase } from './AssignActionStatusDtoModel.base';

/* The TypeScript type of an instance of AssignActionStatusDtoModel */
export interface AssignActionStatusDtoModelType extends Instance<typeof AssignActionStatusDtoModel.Type> { }

/* A graphql query fragment builders for AssignActionStatusDtoModel */
export { selectFromAssignActionStatusDto, assignActionStatusDtoModelPrimitives, AssignActionStatusDtoModelSelector } from './AssignActionStatusDtoModel.base';

/**
 * AssignActionStatusDtoModel
 */
export const AssignActionStatusDtoModel = AssignActionStatusDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
